import { Network } from "../../../Models/Network";
import KnownInternalNames from "../../knownIds";

/**
 * Check if destination network requires wallet connection (generic abstraction)
 * @param network - The destination network
 * @returns boolean indicating if wallet connection is required
 */
export const destinationRequiresWallet = (network: Network | null | undefined): boolean => {
    if (!network) return false;
    // For now, only Aztec requires destination wallet connection
    return network.caip2Id === KnownInternalNames.Networks.AztecDevnet;
};

/**
 * Check if destination wallet is connected for networks that require it
 * @param network - The destination network
 * @param providers - Array of wallet providers
 * @returns boolean indicating if required destination wallet is connected
 */
export const hasRequiredDestinationWallet = (network: Network | null | undefined, providers: any[]): boolean => {
    if (!destinationRequiresWallet(network)) {
        return true; // No wallet required, so consider it "connected"
    }
    
    const destinationProvider = network 
        ? providers.find(p => p.withdrawalSupportedNetworks?.includes(network.caip2Id)) 
        : undefined;
    
    return destinationProvider?.connectedWallets && destinationProvider.connectedWallets.length > 0;
};